let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e3WsQ")).then(() => parcelRequire('8RXG9'));